import React from 'react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import { FaClipboardList } from 'react-icons/fa';

export default function ProjectNeedAssessment() {
  // Get user info from localStorage (same pattern used by every other
  // authenticated page so Sidebar/Topbar render correctly here too).
  const user = JSON.parse(localStorage.getItem('user')) || {
    name: 'Unknown User',
    role: 'Member',
    image: '/user.png',
  };

  return (
    <div className="flex text-white min-h-screen" style={{ background: "var(--bg-base, #070a12)" }}>
      <Sidebar />
      <Topbar user={user} />
      <main className="lg:ml-64 mt-14 w-full px-4 sm:px-6 lg:px-8 py-6 lg:py-10">
        <div className="empty-state">
          <div className="empty-icon"><FaClipboardList /></div>
          <h3>Project Need Assessment</h3>
          <p>This page is coming soon. Check back later for project need assessment tools.</p>
        </div>
      </main>
    </div>
  );
}
